import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/automation/automation-input-modal/automation-input-modal.js';
      

      export interface Props {
     
   }

      

      

      
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAutomationInputModal',
  setup(__props) {

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        

        return h(
          'obc-automation-input-modal',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})